import { useState } from "react";
import "./HomeAbout.scss";
import { Link } from "react-router-dom";
import { tabData } from "../../data/data";

const HomeAbout = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  function handleTabClick(index) {
    setSelectedTab(index);
  }

  const maxContentLength = 400;

  return (
    <section
      className="section homeAbout"
      id="next-section"
      data-aos="fade-up"
      data-aos-duration="1300"
    >
      <article className="homeAbout__container container">
        <div className="section__header">
          <h1 className="section__title">ABOUT US </h1>
          <p className="section__title-center">Wanna know who we are </p>
        </div>
        <div className="homeAbout__container--content">
          <div
            className="homeAbout__container--content-right "
            data-aos="fade-up"
          >
            <div className="homeAbout__nav">
              {tabData.map((tab, index) => (
                <div
                  className={`homeAbout__nav-item ${
                    selectedTab === index ? "current" : ""
                  }`}
                  key={index}
                  onClick={() => handleTabClick(index)}
                >
                  <h3>{tab.title} </h3>
                </div>
              ))}
            </div>

            <div className="homeAbout__contents">
              <p>
                {tabData[selectedTab].content.length > maxContentLength ? (
                  <>
                    {tabData[selectedTab].content.substring(
                      0,
                      maxContentLength
                    )}
                    ...
                    <Link className="link" to="/about">
                      Read More
                    </Link>
                  </>
                ) : (
                  tabData[selectedTab].content
                )}
              </p>
            </div>
          </div>

          <div
            className="homeAbout__container--content-left"
            data-aos="fade-up"
          >
            <iframe
              src="https://www.youtube-nocookie.com/embed/d0NHOpeczUU"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </article>
    </section>
  );
};

export default HomeAbout;
